import { Component } from '@angular/core';
import { ModalController, Loading, ToastController, LoadingController, AlertController, NavController } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TaskDetailPage } from './../../pages/task-detail/task-detail';
import { TaskUpdatePage } from './../../pages/task-update/task-update';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import moment from 'moment';

import { TaskAddPage } from '../../pages/task-add/task-add';

interface myInterface {
  dob: number;
  calendar: [{
    complete: boolean;
    date: Date;
    fileReq: boolean;
    files: [{
      fullPath: string;
      name: string;
      path: string;
    }];
    notes: string;
    task: boolean;
    topic: string;
  }];
  company: string;
  name: string;
  ocupation: string;
  sex: string;
}

interface myInterface2 {
  id: string;
  complete: boolean;
  creationDate: Date;
  description: string;
  dueDate: Date;
  files: any[];
  idAlumno: string;
  idCoach: string;
  idSesion: string;
  title: string;
}

interface myInterface3 {
  id: string;
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: string;
  idCoach: string;
  title: string;
  sessionDate: Date;
  tasks: string[];
}

@Component({
  selector: 'tasks',
  templateUrl: 'tasks.html'
})
export class TasksComponent {

  itemsCollection: AngularFirestoreCollection<myInterface>;
  items: myInterface[];
  tasksCollection: AngularFirestoreCollection<myInterface>;
  tasks: myInterface2[];
  sessionsCollection: AngularFirestoreCollection<myInterface3>;
  sessions: myInterface3[];
  currentUser: any;
  myForm: FormGroup;
  loading: Loading;
  selectedFiles1: FileList;
  file1;
  Files: boolean = false;
  arrayFiles: any[] = [];
  arrayResult: any[] = [];
  idParent: string;
  nameParent: string;
  inputFile: any[] = [""];
  tareas: any[] = [];

  tareasSinSesion: myInterface2[];

  constructor(public navCtrl: NavController, public formBuilder: FormBuilder, public asf: AngularFirestore, public modalCtrl: ModalController, public afAuth: AngularFireAuth, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
    afAuth.auth.onAuthStateChanged(auth => {
      this.itemsCollection = asf.collection("Users", ref => ref.where("coach", "==", auth.uid).where("type", "==", 2).orderBy("uppercaseName","asc"));
      this.itemsCollection.snapshotChanges().subscribe((data) => {
        this.items = data.map((item) => {
          const data = item.payload.doc.data() as myInterface;
          const id = item.payload.doc.id;
          return { id, ...data }
        });
      });
    });
    this.myForm = this.formBuilder.group({
      description: ['', Validators.required],
      dueDate: ['', Validators.required],
      idSesion: ['', Validators.required],
      title: ['', Validators.required]
    });
  }

  selectUser(item: any) {
    if (item && item.id) {
      this.currentUser = item;
      this.tasksCollection = this.asf.collection("Tasks", ref => ref.where("idAlumno", "==", this.currentUser.id).where("idCoach", "==", this.afAuth.auth.currentUser.uid).orderBy("idSesion", "desc"));
      this.tasksCollection.snapshotChanges().subscribe((data) => {
        this.asf.collection("Sessions", ref => ref.where("idAlumno", "==", this.currentUser.id).where("idCoach", "==", this.afAuth.auth.currentUser.uid).orderBy("sessionDate", "desc")).snapshotChanges().subscribe(collection => {
          let array: any[];
          array = [];
          collection.forEach(element => {
            array.push({ "id": element.payload.doc.id, "title": element.payload.doc.data().title, "type": 1, sessionDate: element.payload.doc.data().sessionDate, description: element.payload.doc.data().description, files: element.payload.doc.data().files, idAlumno: element.payload.doc.data().idAlumno, idCoach: element.payload.doc.data().idCoach, qualification: element.payload.doc.data().qualification });
          });
          this.Tasks(array).then(data => {
            this.tareas = [];
            this.tareas = data;
          });
        });
      });
      this.sessionsCollection = this.asf.collection("Sessions", ref => ref.where("idAlumno", "==", this.currentUser.id).where("idCoach", "==", this.afAuth.auth.currentUser.uid).orderBy("sessionDate", "desc"));
      this.sessionsCollection.snapshotChanges().subscribe((data) => {
        this.sessions = data.map((item) => {
          const data = item.payload.doc.data() as myInterface3;
          const id = item.payload.doc.id;
          return { id, ...data }
        });
      });
      this.tasksCollection = this.asf.collection("Tasks", ref => ref.where("idAlumno", "==", this.currentUser.id).where("idCoach", "==", this.afAuth.auth.currentUser.uid).where("idSesion", "==", "sinsesion"));
      this.tasksCollection.snapshotChanges().subscribe((data) => {
        this.tareasSinSesion = data.map((item) => {
          const data = item.payload.doc.data() as myInterface2;
          const id = item.payload.doc.id;
          return { id, ...data }
        });
      });
    }
  }

  async Tasks(elementos: any[]): Promise<any[]> {
    let arreglo: any[] = [];
    for (let x: number = 0; x < elementos.length; x++) {
      await this.asf.collection("Tasks").ref.where("idSesion", "==", elementos[x].id).get().then(datos => {
        arreglo.push(elementos[x]);
        datos.forEach(document => {
          let data = document.data();
          data["id"] = document.id;
          ////console.log(data);
          arreglo.push(data);
        });
      });
    }
    return arreglo;
  }

  selectFile(event: any, id: number) {
    if (event && event.target && event.target.value) {
      this.arrayFiles.push({ "file": event.target.files[0] });
    }
  }

  deleteFromArray(index: number) {
    this.arrayFiles.splice(index, 1);
  }

  addStorage() {
    this.presentLoadingCustom();
    if (this.arrayFiles.length > 0) {
      this.uploadFileSStorage(this.arrayFiles).then(data => {
        this.arrayResult = data;
        this.addUserToDb();
      });
    } else {
      this.addUserToDb();
    }
  }

  addUserToDb() {
    let data = {
      complete: false,
      creationDate: new Date(),
      description: this.myForm.value.description,
      dueDate: new Date(this.myForm.value.dueDate),
      files: this.arrayResult,
      idAlumno: this.currentUser.id,
      idCoach: this.afAuth.auth.currentUser.uid,
      idSesion: this.myForm.value.idSesion,
      title: this.myForm.value.title
    }
    ////console.log(data);
    this.asf.collection('Tasks').add(data).then(res => {
      let arregloTareas: any[];
      let newId = res.id;
      this.asf.doc("Sessions/" + data.idSesion).ref.get().then(datos => {
        if (datos.exists) {
          arregloTareas = datos.exists && datos.data() && datos.data().tasks ? datos.data().tasks : [];
          arregloTareas.push(newId);
          this.asf.doc("Sessions/" + data.idSesion).update({ tasks: arregloTareas }).then(error => {
            this.myForm.reset();
            this.loading.dismiss();
            this.arrayFiles = [];
            this.presentToast("Tarea agregada correctamente");
          }).catch(error => {
            this.loading.dismiss();
            this.presentToast(error);
          });
        } else {
          this.myForm.reset();
          this.loading.dismiss();
          this.arrayFiles = [];
          this.presentToast("Tarea agregada correctamente");
        }
      });
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast(error);
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  async uploadFileSStorage(files: any[]): Promise<any[]> {
    let filesRet: any[] = [];
    for (let x: number = 0; x < files.length; x++) {
      var storageRef = firebase.storage().ref();
      var fileRef = storageRef.child('files/' + new Date().getTime() + files[x].file.name);
      await fileRef.put(files[x].file).then((res) => {
        filesRet.push({ "downloadURL": res.downloadURL, "fullPath": res.metadata.fullPath, "name": files[x].file.name });
      });
    }
    return filesRet;
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  finalizar(event: any, id: string) {
    this.asf.doc("Tasks/" + id).update({ "complete": event.checked }).then(() => {
      ////console.log("Listo");
    }).catch(error => {
      ////console.log(error);
    });
  }

  presentConfirmDelete(id: string, idSesion: string) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar tarea',
      message: '¿Estas seguro de eliminar tarea?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteItem(id, idSesion);
          }
        }
      ]
    });
    alert.present();
  }

  deleteItem(idDocument: string, idSesion: string) {
    this.presentLoadingCustom();
    this.asf.doc("Tasks/" + idDocument).delete().then(() => {

      let arregloTareas: any[];

      ////console.log(idSesion);
      this.asf.doc("Sessions/" + idSesion).ref.get().then(document => {
        arregloTareas = document.data() && document.data().tasks ? document.data().tasks : [];

        let index = arregloTareas.indexOf(idDocument);

        if (index > -1) {
          arregloTareas.splice(index, 1);
          this.asf.doc("Sessions/" + idSesion).update({ tasks: arregloTareas }).then(() => {
            this.presentToast('Eliminado correctamente');
            this.loading.dismiss();
          }).catch(error => {
            ////console.log(error);
            this.loading.dismiss();
            this.presentToast('¡Ha ocurrido un error!');
          });

        } else {
          this.presentToast('Ha ocurrido un error');
          this.loading.dismiss();
        }

      });

    }).catch(error => {
      ////console.log(error);
      this.loading.dismiss();
      this.presentToast('¡Ha ocurrido un error!');
    });
  }

  updateItem(item: any) {
    let Modal = this.modalCtrl.create(TaskUpdatePage, { "item": item });
    Modal.present();
  }

  viewItem(item: any) {
    let Modal = this.modalCtrl.create(TaskDetailPage, { "item": item });
    Modal.present();
  }

  stringDate(date: any): string {
    if (date == '') {
      return "Sin fecha asignada"
    } else {
      moment.locale("es");
      return moment(date).format("lll");
    }
  }
  presentModal() {
    let Modal = this.modalCtrl.create(TaskAddPage, { "userId": this.currentUser });
    Modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/tasks/tasks.ts